import FnEditorElement from "../FnEditorElement";
export default class InsertElementAction {
    constructor(id, afterId, text) {
        this.id = id;
        this.afterId = afterId;
        this.text = text;
        this.type = 'insertElement';
        this.time = Date.now();
    }
    apply(state, dom, logger) {
        var _a;
        const domElement = dom.insertAfter(this.id, this.afterId);
        const element = new FnEditorElement(this.id, (_a = this.text) !== null && _a !== void 0 ? _a : '');
        state.elements.insertAfter(element, this.afterId);
        element.syncWithDom(domElement);
        return {
            idsToEvaluate: [this.id]
        };
    }
    undo(state, dom, logger) {
        var _a, _b;
        if (!this.id) {
            return { idsToEvaluate: [] };
        }
        const idsToEvaluate = [];
        const prevId = (_a = state.elements.getPreviousOf(this.id)) === null || _a === void 0 ? void 0 : _a.getId();
        if (prevId) {
            idsToEvaluate.push(prevId);
        }
        const nextId = (_b = state.elements.getNextOf(this.id)) === null || _b === void 0 ? void 0 : _b.getId();
        if (nextId) {
            idsToEvaluate.push(nextId);
        }
        state.elements.removeById(this.id);
        dom.removeById(this.id);
        return {
            idsToEvaluate
        };
    }
    getDataToMergeWithNext(nextType) {
        return {};
    }
    mergeWithPrevious(previousType, previousData) {
        return false;
    }
}
